import { MessageFilled } from "@ant-design/icons";
import { FC, useCallback } from "react";
import { TaskFinGroupPhotosEntity, TaskStatus } from "tm-shared/types";

import { StatusCycleButton } from "@/components/CycleButton";
import FlexContainer from "@/components/FlexContainer";
import { StatusIndicator } from "@/components/Status/StatusIndicator";
import { PrimaryText } from "@/components/Typography/Styled";

import { StyledCommentIndicator, StyledTask } from "./Styled";

interface TaskFinGroupPhotosProps {
    item: string;
    isActive: boolean;
    onChangeActive: (id: string) => void;
    payload: TaskFinGroupPhotosEntity | undefined;
    onChangeTaskStatus: (status: TaskStatus, id?: string) => void;
}

export const TaskFinGroupPhotos: FC<TaskFinGroupPhotosProps> = ({
    item,
    isActive,
    onChangeActive,
    payload,
    onChangeTaskStatus,
}) => {
    const hasComment = !!payload?.comment;
    const status = payload?.status ?? TaskStatus.Incomplete;
    const photoCount = payload?.photos?.length ?? 0;

    const selectTask = useCallback(() => {
        onChangeActive(item);
    }, [item]);

    const handleChangeTaskStatus = useCallback(
        (status: TaskStatus) => {
            onChangeTaskStatus(status, item);
        },
        [item],
    );

    return (
        <StyledTask $isActive={isActive} onClick={selectTask}>
            <PrimaryText>Фото категорії: {item}</PrimaryText>

            <FlexContainer>
                <StyledCommentIndicator>
                    {hasComment && (
                        <StatusIndicator type="warning">
                            <MessageFilled />
                        </StatusIndicator>
                    )}
                </StyledCommentIndicator>

                <StatusCycleButton
                    value={status}
                    onChange={handleChangeTaskStatus}
                    states={[TaskStatus.Incomplete, TaskStatus.Rejected]}
                    disabled={status === TaskStatus.Completed}
                    photoMode
                    photoCount={photoCount}
                    dimension={48}
                    border={false}
                />
            </FlexContainer>
        </StyledTask>
    );
};
